<template>
 

  <div class="auth">
        <div class="container">
            <ul class="nav auth--tabs-list login-tab-list">
             
                <li>
                    <button v-on:click="activetab=2" :class="[ activetab === 2 ? 'auth--tab-button student-tab active' : 'auth--tab-button student-tab' ]" type="button" data-bs-toggle="pill" data-bs-target="#studentTab">{{$t('Student')}}</button>
                </li>
            </ul>
            <div class="tab-content">
           <div :class="[ activetab === 2 ? 'tab-pane fade show active tab-student-content' : 'tab-pane fade tab-student-content' ]" id="studentTab">




    <div class="auth--box">
        <div class="auth--box--header small-margin">
            <h2 class="auth--title">{{$t('login as student')}}</h2>
        </div>
        <form>
            <div :class="{'form--group':true,'form--error':showValidMessage&&errors.has('email')}">
                <input v-on:keyup.enter="login" class="form--control" type="text" :placeholder="$t('Email')" id="email2" name="email" v-model="model.username" v-validate="'required|email'" maxlength="50">
                <p v-show="showValidMessage&&errors.has('email')" class="form--error-text">{{ errors.first('email') }}</p>
            </div>
            <div :class="{'form--group':true,'form--error':showValidMessage&&errors.has('password')}">
                <input v-on:keyup.enter="login" class="form--control" type="password" :placeholder="$t('Password')" id="password2" name="password" v-model="model.password" v-validate="'required'" maxlength="50">
                <p v-show="showValidMessage&&errors.has('password')" class="form--error-text">{{ errors.first('password') }}</p>
            </div>
            <div class="form--group">
                <input class="form-check-input" id="remember-check32" type="checkbox" v-model="rememberme">
                <label class="form-check-label" for="remember-check32">{{$t('Remember me')}}</label>
            </div>
            <button class="btn-round auth-btn" type="button" @click="login">{{$t('Login')}}</button>
            <div class="text-center"><router-link class="auth--forget-password-link" to="/ForgetPassword">{{$t('forget password')}}</router-link></div>
            <p class="auth--have-account">{{$t('Dont have an account')}}
                 <router-link class="auth--forget-password-link" to="/Register/2">{{$t('goregister')}}</router-link></p>
            <div class="auth--login-with">
                <p>{{$t('Login with')}}:</p>
                <ul class="social-list list-unstyled">
                    <li>
                        <FacebookLogin></FacebookLogin>
                    </li>
                    <li>
                        <LinkedinLogin></LinkedinLogin>
                    </li>
                    <li>
                        <GoogleLogin></GoogleLogin>
                    </li>
                </ul>
            </div>
        </form>
    </div>
                </div>
            </div>
        </div>
  </div>
</template>
<script>
    import $ from 'jquery'
    import GlobalMixin from '@/GlobalMixin.js'
    import FacebookLogin from '@/components/FacebookLogin.vue'
    import LinkedinLogin from '@/components/LinkedinLogin.vue'
    import GoogleLogin from '@/components/GoogleLogin.vue'
    import { mapActions } from "vuex";

    export default {
        mixins: [GlobalMixin],
        components: { FacebookLogin, LinkedinLogin, GoogleLogin },
        data() {
            return {
                activetab:2
            }
        },
        methods: {
            ...mapActions(["StoreUser"]),
            login() {
                var self = this;
                self.showValidMessage = true;
                if (self.rememberme) {
                    localStorage.username = self.model.username;
                    localStorage.rememberme = true;
                }
                else {
                    localStorage.username = "";
                    localStorage.rememberme = "";
                }
                let valid = self.customValidate();
                self.$validator.validate().then(function (result) {
                    if (!result || !valid) { ////not valid
                        let detail = $('.form--error').first()[0];
                        if (detail) {
                            detail.scrollIntoView({ behavior: 'smooth', block: 'end' });
                        }
                        return;
                    }
                    $('.form--error').removeClass("form--error");
                    self.closeErrorAlert();
                    self.ShowLoading();
                    self.model.user_type = "student";
                    let url = process.env.VUE_APP_APIEndPoint +'auth/token/'
                    self.axios.post(url, self.model, self.headers)
                        .then(function (res) {
                            if (res.data.success) {
                                self.model = {};
                                //localStorage.token_data = res.data.token_data;
                                //localStorage.user = res.data.user;
                                //self.headers.headers.Authorization = "Bearer " + res.data.token_data.access_token                                
                                self.notify(self.$t('login success'), "success");
                                self.StoreUser(res.data);
                                


                            var webinarId = self.$route.params.id;
                            console.log(webinarId);
                            let subscribe = {
                                    user: res.data.user.id,
                                    webinar: webinarId,
                                    };
                            var headers= {
                                                    headers:
                                                    {
                                                    Authorization: ('Bearer '+ self.$store.getters.StateUser?.token_data?.access_token),                         
                                                    "accept-language":localStorage.lang,
                                                    "CLIENT-ID":process.env.VUE_APP_CLIENTID,
                                                    "Client-Secret": process.env.VUE_APP_ClientSecret,
                                                    "USER-TIMEZONE": Intl.DateTimeFormat().resolvedOptions().timeZone
                                                    }
                                                }
                                    self.axios
                                    .post(
                                        self.baseUrl + `p2p/webinars/${webinarId}/subscribed-users/`,
                                        subscribe,
                                        headers
                                    )
                                    .then(function (res) {
                                        if (res.data) {              
                                        if (res.data.webinar_status == "active") {
                                            self.$router.push({ name: "Webinars" });
                                            // window.open(res.data.join_url, "_blank");
                                        } else if (res.data.webinar_status == "not_started") {
                                            self.notify(self.$t("RegisterWebinarSucess"), "success");
                                            self.$router.push({ name: "Webinars" });
                                        }
                                        } else {
                                        self.notify(self.$t(res.data.Messages[0].Message), "error");
                                        }
                                    })
                                    .catch(function (err) {
                                        self.displayError(err);
                                        return console.log(err);
                                    })
                                    .finally(function () {
                                        return self.HideLoading();
                                    });


                                //alert(self.$store.getters.isAuthenticated);
                                //self.$router.push({ name: 'Home' });
                            }
                            else {
                                self.notify(self.$t(res.data.Messages[0].Message), "error");
                            }
                        })
                        .catch(function (err) {
                            self.displayError(err);
                        }).finally(function () {
                            return self.HideLoading();
                        })
                })
            },
            AfterMountedFn() {
                let self = this;
                if (self.rememberme == "true") {
                    self.model.username = localStorage.username
                }
            }

        }
    }
</script>